<template>
  <div>
    <app-header />
    <div class="jumbotron jumbotron-fluid">
      <div class="container text-center pb-5">
        <h1 class="display-4">
          Chrono Logic
          <strong>Online</strong>
        </h1>
        <p class="lead">
          <strong>Calculate</strong> &
          <strong>visualize</strong> the
          <strong>Chrono</strong> window
          hardware system
        </p>
      </div>
      <div class="container">
        <!-- Example row of columns -->
        <div class="row">
          <div class="col-md-6">
            <h2>Calculate</h2>
            <p>
              With Chrono Logic Online you can easily calculate the hardware parts and sets needed for each type of
              window. The bill of materials is generated automaticaly based on the chosen options. The output is
              formatted as .CSV.
            </p>
          </div>
          <div class="col-md-6">
            <h2>Visualize</h2>
            <p>
              Chrono Logic Online generates PDF files with detailed visual information for easy mounting of our Chrono
              window hardware. The length and position of the rods in the vent and the position of the frame parts are
              shown on a dedicated drawing for each window.
            </p>
          </div>
        </div>
        <hr />

        <div class="text-center mt-5">
          <button class="btn btn-primary" v-on:click="openLoginPage">Get Started</button>
          <button class="btn btn-primary" v-on:click="openTCPage">Terms &amp; Conditions</button>
          <button class="btn btn-primary" v-on:click="openPPPage">Privacy Policy</button>
        </div>
      </div>
      <!-- /container -->
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from "./AppHeader";
import AppFooter from "./AppFooter";

export default {
  components: {
    AppHeader,
    AppFooter
  },
  methods: {
    openLoginPage() {
      this.$router.push("/login");
    },
    openTCPage() {
      this.$router.push("/terms-and-conditions");
    },
    openPPPage() {
      this.$router.push("/privacy-policy");
    }
  },
  created() {
    if (this.$route.query.pwr == 1)
      this.$router.push(
        "/pw/" + this.$route.query.id + "?token=" + this.$route.query.token
      );
  }
};
</script>




// WEBPACK FOOTER //
// src/components/intro/AppIntro.vue